module.exports = __webpack_public_path__ + "cf93e15c8d640b88eac3264f41fa8e01.svg";